module.exports = __webpack_public_path__ + "static/media/spinStart.0b14d15c.mp3";